import { setAppMode } from '../../redux/AppModeState/AppModeState.actions';
import { loadMOP, resetPaymentForm } from '../../redux/PaymentState/PaymentState.actions';
import { setEditableMop, setSelectedMop } from '../../redux/MopOnFileState/MopOnFileState.actions';
import { getString } from '../../constants/Strings';
import { ElementType, sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
export var setModeClickHandler = function setModeClickHandler(mode, goBackMode, dispatch) {
  return dispatch(setAppMode({
    mode: mode,
    goBackMode: goBackMode
  }));
};

/**
 * Controls behavior when user clicks on a link to go into edit mode.
 * @param mop the mop that the user will edit.
 * @param dispatch a dispatch hook
 * @param hostedFieldsService an instance of hfs
 */

export var onEdit = function onEdit(params) {
  var mop = params.mop,
    dispatch = params.dispatch,
    hostedFieldsService = params.hostedFieldsService,
    rioNamespace = params.rioNamespace,
    isReviewStep = params.isReviewStep;
  dispatch(resetPaymentForm());
  dispatch(setEditableMop({
    mop: mop
  }));
  dispatch(setSelectedMop({
    mop: mop
  }));
  hostedFieldsService && dispatch(loadMOP({
    selectedMop: mop,
    instance: hostedFieldsService
  }));

  //Rio logging: Edit Clicked On Payment Method Component
  // Different rio log on click of edit for review step on DIP
  sendRioEvent({
    info: isReviewStep ? getString('APP.RIO.EVENTS.EL_NAME.EDIT_PAYMENT_INFO') : getString('APP.RIO.EVENTS.EL_NAME.EDIT_PAYMENT_METHOD_CLICKED'),
    specType: SpecType.INTERACTION,
    subType: SubType.CLICK,
    elementType: isReviewStep ? ElementType.LINK : ElementType.BUTTON,
    callback: sendRioEventCallback,
    namespace: rioNamespace
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/DefaultMopView/helpers.js
// module id = 337
// module chunks = 11